import React from "react";
import "../../css/insightsView.css";
import "../../css/insightsOneView.css";
import ContentPage from "../../components/content-page";
import Meta from "../../components/meta";
import PropTypes from "prop-types";
import Link from "gatsby-link";
import Modal from "../../components/Modal";
import { insightsConstants } from "../../constant/insights_constants";
import { DropdownButton, MenuItem } from "react-bootstrap";
import { ClipLoader } from "react-spinners";
import $ from "jquery";
import MediaQuery from "react-responsive";
import "animate.css/animate.min.css";
import ScrollAnimation from "react-animate-on-scroll";
import ReactPlayer from "react-player";
import emailForwardIcon from "../../images/icons/send-mail-icon.jpg";
import MailForwardForm from "../../components/MailForwardForm";

const icon1 =
  "https://winpeforum.com/assets/elements/WinPE_ALS2021_linkpreview-03.jpg";

const TeamModal = ({ activeItem, show, onHide }) => {
  return (
    <Modal
      direction=""
      className="teamdetails__wrapper"
      show={show}
      onHide={onHide}
      style={{ margin: "0% auto 0px" }}
    >
      <Modal.Header>
        <div className="head_section">
          <span className="item_name">{activeItem.name}</span>
          <div className="item_des">{activeItem.post}</div>
          <div className="item_des">{activeItem.company}</div>
        </div>
        <span className="cross pull-right">
          <i onClick={onHide} className="fa fa-times" />
        </span>
      </Modal.Header>
      <Modal.Body>
        <div className="item__desc">
          <div dangerouslySetInnerHTML={{ __html: activeItem.desc }}></div>
        </div>
      </Modal.Body>
      <Modal.Footer />
    </Modal>
  );
};
TeamModal.propTypes = {
  activeItem: PropTypes.object,
  show: PropTypes.object,
  onHide: PropTypes.object,
};

export class uppingthestakes extends React.Component {
  constructor(args) {
    super(args);
    this.state = {
      activeItem: {},
      isShow: false,
      activeKeyword: "",
      isSearching: false,
      lastCounter: 3,
      activeTitle: "SORT BY",
      activeSortBy: "default",
      showMailShareForm: false,
    };

    this.betterContent = insightsConstants;
    this.TabContent = [
      // {
      // 	title: "POPULARITY",
      // },
      {
        title: "ALL",
      },
      {
        title: "BLOGS",
      },
      {
        title: "INFOGRAPHICS",
      },
      {
        title: "INTERVIEWS",
      },
      {
        title: "VIDEOS",
      },
    ];
    this.Speaker = [{}];
    this.Speaker = [
      {
        desc: `<div></div>`,
        name: "",
        post: "The Alicorn Leadership Summit 2021",
        imgUrl: icon1,
        head: "Upping the Stakes",
      },
    ];
    this.SpeakerContent = [
      {
        desc: `<div>Gopal Jain is Managing Partner and Co-founder of Gaja Capital (www.gajacapital.com), an India-focused growth & buyout firm based in Mumbai. Founded in 2005, Gaja is a leading player in India’s private equity market with an exceptional track record of 20+ investments and an AUM of over $500m. Gaja has invested consistently in India’s mid-market across themes in education, financial services & consumer. Gaja Capital has been adjudged as the best Indian mid-market PE firm thrice in the last 10 years (Venture Intelligence). Home grown, Gaja Capital is one of the few indigenous PE firms in India to operate at scale.
        <br/><br/>
        Gopal leads both the executive and investment functions at the firm and has personally led several of the Firm’s investments. Gopal has been investing in Indian equities since the age of thirteen and has been a professional investor in the Indian capital markets for almost thirty years. He is one of the more experienced private equity investors in India, having led or co-led over 25 private equity investments since his first investment in TV-18 in 1995. Several of the companies Gopal has backed have grown 10x in value since the investment. Prior to Gaja Capital, he was country head for the Boston-based View Group one of the pioneers in Indian private equity.
        <br/><br/>
        Gopal is an active columnist and is currently member of SEBI’s Alternative Investment Policy Advisory Committee and Indian Private Equity and Venture Capital Association’s Executive Committee. He has a deep interest in the social sector and leads Gaja Gives which supports a wide and growing number of philanthropic efforts in India.
        <br/><br/>
        Gopal is a Graduate in Electrical Engineering from IIT Delhi. He is remembered on the campus for being one of the first graduates from the institute to turn entrepreneur before graduating. He currently lives in Mumbai with his mother Sudesh, wife Chitra and daughters Srishti and Ira.
        <br/><br/>
        Gaja Capital’s investments include : Eurokids, RBL Bank, TeamLease & John Distilleries. A longer list is available on their website.</div>`,
        name: "Gopal Jain",
        company: "Gaja Capital",
        post: "Managing Partner",
        fullname: `<div><b>Gopal Jain</b>, Managing Partner, Gaja Capital &nbsp;</div>`,
      },
      {
        desc: `<div>GV Ravishankar is a Managing Director at Sequoia Capital India. At Sequoia, GV Ravishankar advises on both technology as well as non-technology investments. He’s deeply interested in technology’s role in helping to drive efficiencies, reduce costs and improve access in consumer and healthcare markets.
        <br/><br/>
        He currently serves on the boards of BYJUs, Capital Float, Eruditus Learning, Faces Cosmetics, Five Star finance, Finova Capital, HomeLane, India Shelter Finance Corporation, Indigo Paints, K12 Technoservices, Prataap Snacks (NSE: DIAMONDYD), Rebel Foods, Rupeek, Suburban Diagnostics and Turtlemint. I have also served as board member/observer of companies like Via (sold to NASDAQ: EBIX ), Manappuram (NSE: MANAPPURAM) and Equitas (NSE: EQUITAS).
        <br/><br/>
        Prior to this, GV worked at McKinsey & Company, where he advised senior management of top Indian companies on a variety of issues including business building, channel management and leadership development. He also had a prior stint with Wipro Technologies in their Embedded and Internet Access division.
        <br/><br/>
        GV has an MBA from IIMA and holds a BE in Computer Science and Engineering from NIT Trichy. 
		        </div>`,
        name: "GV Ravishankar",
        company: "Sequoia Capital India",
        post: "Managing Director",
        fullname: `<div> <b>GV Ravishankar</b>, Managing Director, Sequoia Capital India</div>`,
      },
      {
        desc: `<div>Harsh is Managing Director at CDPQ, responsible for the externally managed investing program in India. Prior to joining CDPQ, Harsh worked with International Finance Corporation (IFC) in New Delhi. Prior to joining IFC, Harsh has worked with Boston Consulting Group and PriceWaterhouseCoopers, where he worked on diverse topics ranging from investment structuring, M&A and operational improvement in companies.
        <br/> <br/>
        Harsh is a fellow member of the Institute of Chartered Accountants of India (Indian CPA) and an MBA from the Indian School of Business, Hyderabad.
		        </div>`,
        name: "Harsh Singhal",
        company: "CDPQ India",
        post: "Managing Director",
        fullname: `<div><b>Harsh Singhal</b>, Managing Director, CDPQ India &nbsp;</div>`,
      },
      {
        desc: `<div>Janette Hall is a Director in ADB’s Private Sector Operations Department in charge of the Bank’s private equity funds and blended finance program. She joined ADB in January 2011.
        <br/><br/>
        Previously, Mrs. Hall was a senior banker in the Investment Banking Group at Bank of America San Francisco as well as in the Corporate Finance Group at KPMG New York, where she focused on mergers, acquisitions, divestitures, restructurings, debt capital raises and public/private equity capital raises. Ms. Hall began her career as an audit associate with Ernst & Young LLP, USA.
        <br/><br/>
        Mrs. Hall obtained her bachelor in arts degree from the University of California, Berkeley, Haas School of Business, after which she obtained her MBA from the University of Chicago, Booth School of Business.
		        </div>`,
        name: "Janette Hall",
        company: "Asian Development Bank",
        post: "Director, Investment Funds",
        fullname: `<div><b>Janette Hall</b>, Director, Investment Funds, Asian Development Bank</div>`,
      },
      {
        desc: `<div> Nupur Garg is a leading investor in private equity and venture capital and an expert advisor to large institutional investors. She is the founder of Winpe, a not-for-profit initiative to enhance gender diversity in the investing ecosystem.<br/><br/> Nupur serves as Chairperson of the board of Kids Clinic India Limited and an independent director on the boards of companies including Indigo Paints Limited, Kerala Infrastructure Fund Management Limited and SIDBI, the Indian development finance institution. She is an independent member of the investment committee at the Fund of Funds managed by the National Investment and Infrastructure Fund (NIIF), the quasi sovereign wealth fund sponsored by the government of India, and an advisor to and a member of the investment committee for the Dutch Good Growth Fund (DGGF) investment funds mandate given by the Dutch government for investments in SMEs in frontier markets across 75 countries. She has served as an external expert on the investment committee for the INR 10,000 crore Fund of Fund for Start-ups for investing in the Indian start-up ecosystem. Nupur advises select fund managers on a confidential basis on matters related to institutionalization, best practices and governance. She also mentors female entrepreneurs across various platforms. <br/><br/>
        
        Nupur was listed in the BW VC World Most Influential Women 2022, Forbes W-Power list of Self Made Women 2020, among India's top 100 Women Leaders in Finance (AIWMI 2019), awarded the Women Empowerment Entrepreneur Award 2019-20 and the Business Excellence and Innovative Best Practices - Academia Award 2019. <br/><br/>
In her last and most recent full time role, Nupur led the private equity and venture capital funds business in the region for IFC and is widely credited with establishing IFC's brand and credibility as one of the most respected institutional investors in this space. Under her stewardship, the portfolio doubled in size and returns, moving from a negative IRR to delivering gains for the first time in its history. <br/><br/>Nupur is a CA and an MBA from MIT Sloan School of Management, with executive education from Harvard Business School. Nupur loves to spend time with her mother, husband and 6 year-old son, travel to new places, read and do 1000-piece puzzles.
		        </div>`,
        name: "Nupur Garg",
        company: "Winpe",
        post: "Investor & Independent Director, & Founder",
        fullname: `<div><b>Nupur Garg</b>, Investor & Independent Director, & Founder, Winpe</div>`,
      },
      {
        desc: `<div>Sujoy is a business leader with over three decades of extensive experience in emerging markets investing and project finance, covering infrastructure, industrials and services sectors. During his career, he has worked on projects covering over 50 countries across Asia, Africa, Europe, Middle East, Latin America and the Caribbean.
        <br/><br/>
        He joined NIIF as the MD & CEO in 2016 and is currently based in Mumbai.
        <br/><br/>
        Prior to joining NIIF, he spent over 25 years at International Finance Corporation (IFC), the private sector investment and financing arm of the World Bank Group. During his tenure at IFC, he has held several leadership positions, with his last position being Director and Global Co-Head, Infrastructure and Natural Resources, based in Washington DC, managing a USD 14 billion portfolio.
        <br/><br/>
        Prior to this position, he also served as the Chief Investment Officer and Head of IFC’s African Latin American and Caribbean Fund, based in Washington DC, where he managed and led a USD 1 billion regional growth fund to selectively co-invest with IFC.
        <br/><br/>
        From 2006-2010, Sujoy led IFC’s Mumbai office and was responsible for managing its growth and building a strong team of 40 investment professionals as an important part of IFC’s goals for localization of its business. He started his career as a Management Associate with Citibank in Chennai in 1991 as part of the Credit Cards business within the Consumer Banking Group.
        <br/><br/>
        Sujoy holds a Bachelor’s in Commerce from St. Xavier’s College, Kolkata, India and is an MBA in Finance from Rice University, Houston, Texas.
		        </div>`,
        name: "Sujoy Bose",
        company: "National Investment & Infrastructure Fund",
        post: "MD & CEO",
        fullname: `<div><b>Sujoy Bose</b>, MD & CEO, National Investment & Infrastructure Fund</div>`,
      },
      {
        desc: `<div>Vishal Mahadevia is a Managing Director, Head of India, and member of the Executive Management Group. Prior to joining Warburg Pincus in 2006, he was a Principal at Greenbriar Equity Group, a fund focused on private equity investments in the Transportation sector. Prior to that, Mr. Mahadevia worked at Three Cities Research, a New York-based private equity fund and as a consultant with McKinsey & Company. He currently serves as a Managing Director of Warburg Pincus India Private Limited. Mr. Mahadevia is also a Director of Gangavaram Port Limited and IDFC First Bank Limited. He received a B.S. in Economics with a concentration in Finance and a B.S. in Electrical Engineering from the University of Pennsylvania.
		        </div>`,
        name: "Vishal Mahadevia",
        company: "Warburg Pincus India",
        post: "Managing Director",
        fullname: `<div><b>Vishal Mahadevia</b>, Managing Director, Warburg Pincus India</div>`,
      },
    ];
  }
  componentDidMount() {
    // function sticky_relocate () {
    // 	var window_top = $(window).scrollTop()
    // 	var div_top = $("#sticky-anchor").offset().top
    // 	if (window_top > div_top) {
    // 		$("#sticky").addClass("stick")
    // 	} else {
    // 		$("#sticky").removeClass("stick")
    // 	}
    // }
    // $(function () {
    // 	$(window).scroll(sticky_relocate)
    // 	sticky_relocate()
    // })
    // window.location = "/";
  }

  toggleMailShareForm = () => {
    this.setState({ showMailShareForm: !this.state.showMailShareForm });
  };

  togglePopUp = (item) => {
    this.setState({
      isShow: !this.state.isShow,
      activeItem: item || {},
    });
  };
  handleMenu = (item) => {
    this.setState({
      activeTitle: item.title,
    });

    let leftlist = [...insightsConstants];
    this.betterContent = [];
    if (item.title === "SORT BY") {
      []
        .concat(leftlist)
        // .filter((a) => a.r_type === "Appetizer")
        .forEach((item, i) => this.betterContent.push(item));
    } else if (item.title === "ALL") {
      []
        .concat(leftlist)
        // .filter((a) => a.r_type === "Appetizer")
        .forEach((item, i) => this.betterContent.push(item));
    } else {
      []
        .concat(leftlist)
        .filter((insight) => {
          console.log(insight);
          // a.typee.indexOf(item.title) >= 0}
          let flag = false;
          for (let i = 0; i < insight.itype.length; i++) {
            if (item.title === insight.itype[i]) {
              flag = true;
            }
          }
          return flag;
        })
        .forEach((item, i) => this.betterContent.push(item));
    }
    this.setState({
      activeSortBy: item.title,
    });
    setTimeout(() => {
      this.setState({
        isSearching: false,
      });
    }, 1000);
  };
  handleSearch = (e) => {
    let str = e.target.value.length ? e.target.value.toLowerCase().trim() : "";
    this.setState({
      isSearching: true,
      activeKeyword: str,
    });
    let leftlist = [...insightsConstants];
    this.betterContent = [];
    leftlist.forEach((item) => {
      if (
        item.skey
          .toLowerCase()
          .trim()
          .search(str) > -1
      ) {
        this.betterContent.push(item);
      }
    });
    setTimeout(() => {
      this.setState({
        isSearching: false,
      });
    }, 1000);
  };
  render() {
    const {
      defaultStyle,
      isSearching,
      isShow,
      activeTitle,
      activeSortBy,
    } = this.state;
    const { location } = this.props;
    // return null;

    const leftList = this.betterContent.filter(
      (item) => item.url !== "/uppingthestakes"
    );

    return (
      <div>
        <MailForwardForm
          show={this.state.showMailShareForm}
          onClickClose={this.toggleMailShareForm}
          url={"insights.php/forward"}
          insight="Upping the Stakes"
        />
        <ContentPage>
          <Meta
            title="Winpe Insights | Upping the Stakes"
            image={
              "https://winpeforum.com/assets/elements/uppingthestakes_linkpreview.jpg"
            }
            description="Upping the Stakes, a forum for a candid and open dialogue between fund managers and investors for gender diversity."
            location={location}
          />
          <Meta
            title="Winpe Insights | Upping the Stakes"
            image={
              "https://winpeforum.com/assets/elements/uppingthestakes_linkpreview.jpg"
            }
            description="Upping the Stakes, a forum for a candid and open dialogue between fund managers and investors for gender diversity."
            location={location}
          />
          <div className="section__content">
            <div className="insights_wrapper">
              <div className="insights_section">
                <MediaQuery query="(min-width: 768px)">
                  <div className="insights_main_heading">
                    <div className="left_line"></div>
                    <div className="insights_main_heading_text">
                      Winpe INSIGHTS
                    </div>
                  </div>
                </MediaQuery>
                <MediaQuery
                  query="(min-width: 767px)"
                  style={{ display: "none" }}
                >
                  <div className="insights_main_heading"></div>
                </MediaQuery>
                <div className="insights_content">
                  <div className="drop_src_box">
                    <MediaQuery query="(min-width: 768px)">
                      <div className="left_drop_box">
                        <DropdownButton title={activeTitle}>
                          {this.TabContent.map((item, j) => {
                            return (
                              <MenuItem
                                onClick={() => this.handleMenu(item)}
                                activeSortBy={activeSortBy}
                                text={item.title}
                                key={j}
                              >
                                {item.title}
                              </MenuItem>
                            );
                          })}
                        </DropdownButton>
                      </div>
                    </MediaQuery>
                    <MediaQuery
                      query="(max-width: 767px)"
                      style={{ display: "none" }}
                    >
                      <div className="left_drop_box">
                        <DropdownButton title={activeTitle}>
                          {this.TabContent.map((item, j) => {
                            return (
                              <MenuItem
                                onClick={() => this.handleMenu(item)}
                                activeSortBy={activeSortBy}
                                text={item.title}
                                key={j}
                              >
                                {item.title}
                              </MenuItem>
                            );
                          })}
                        </DropdownButton>
                      </div>
                    </MediaQuery>
                    <MediaQuery query="(min-width: 768px)">
                      <div className="left_scr_box">
                        <form id="demo-2">
                          <input
                            type="search"
                            placeholder="Search"
                            onChange={(e) => this.handleSearch(e)}
                            value={this.state.activeKeyword}
                          />
                        </form>
                      </div>
                    </MediaQuery>
                    <MediaQuery
                      query="(max-width: 767px)"
                      style={{ display: "none" }}
                    >
                      <div className="left_scr_box"></div>
                    </MediaQuery>
                  </div>
                  <div className="insights_mid_section">
                    <div className="row">
                      <MediaQuery query="(min-width: 768px)">
                        <div className="col-lg-3 col-md-3">
                          <div id="sticky-anchor"></div>
                          <div className="insights_left_listing">
                            <div className="insights_left_listing_text">
                              <div className="left_listing_card left_listing_card--feature">
                                <div className="listing_t1">
                                  <span>Video&nbsp;</span>
                                  &#8226; 21 January 2021
                                </div>
                                <div className="listing_t2">
                                  Upping the Stakes
                                </div>
                                <div className="listing_t3">
                                  Alicorn Leadership Summit 2021
                                </div>
                              </div>
                              {isSearching ? (
                                <div style={{ margin: "10% 25% 10%" }}>
                                  <ClipLoader
                                    color={"#22316B"}
                                    loading={isSearching}
                                  />
                                </div>
                              ) : leftList.length ? (
                                leftList.slice(0, 27).map((item, i) => {
                                  return (
                                    <div className="left_listing_card" key={i}>
                                      <Link
                                        to={`/insights/${item.url.replace(
                                          /[^A-Z0-9]+/gi,
                                          ""
                                        )}`}
                                      >
                                        <div className="listing_t1">
                                          <span>{item.type}&nbsp;</span>
                                          &#8226; {item.date}
                                        </div>
                                        <div className="listing_t2">
                                          {item.ltitle}
                                        </div>
                                        <div className="listing_t3">
                                          {item.lname}
                                        </div>
                                      </Link>
                                    </div>
                                  );
                                })
                              ) : (
                                <div className="no__product">
                                  Not available in the list
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </MediaQuery>
                      <MediaQuery
                        query="(max-width: 767px)"
                        style={{ display: "none" }}
                      >
                        <div className="col-lg-3 col-md-3">
                          <div id="sticky-anchor"></div>
                          <div className="insights_left_listing"></div>
                        </div>
                      </MediaQuery>
                      <div className="col-lg-9 col-md-9">
                        <ScrollAnimation
                          delay={0}
                          duration={2}
                          animateIn="slideInRight"
                          offset={600}
                        >
                          <div className="insights_right_text">
                            <div className="insights_blog_page">
                              <div className="back_event">
                                <Link to="/insights">
                                  <i className="fa fa-arrow-left">
                                    {" "}
                                    browse Insights
                                  </i>
                                </Link>
                              </div>
                              <div className="insights_blog_text">
                                {this.Speaker.map((item, i) => {
                                  return (
                                    <div className="row">
                                      <ScrollAnimation
                                        delay={0}
                                        duration={1}
                                        animateIn="zoomIn"
                                        offset={100}
                                      >
                                        <div className="col-md-4 col-sm-6">
                                          <div className="right_img_section">
                                            <a
                                              href="http://alicornsummit.winpeforum.com/"
                                              target="_blank"
                                            >
                                              <img
                                                src={item.imgUrl}
                                                alt="nupur_garg"
                                                className="img-responsive"
                                              />
                                            </a>
                                          </div>
                                        </div>
                                        <div className="col-md-8 col-sm-6">
                                          <div className="right_name_section">
                                            <div className="r_head">
                                              Upping the Stakes
                                            </div>
                                            <div className="r_name"></div>
                                            <div className="r_post">
                                              The Alicorn Leadership Summit 2021
                                              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                              &nbsp;&nbsp;&nbsp;&nbsp;
                                              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                            </div>
                                            <div className="r_block">
                                              <span>VIDEO</span> &#8226; 1.5
                                              hour video
                                            </div>
                                          </div>
                                          <div className="share_section_one">
                                            <div className="headsocialLink">
                                              <span className="hicon">
                                                <a
                                                  href={`https://www.facebook.com/sharer/sharer.php?u=https://winpeforum.com${location.pathname}`}
                                                  target="_blank"
                                                  className=""
                                                  style={{
                                                    display: "block !important",
                                                  }}
                                                >
                                                  <img
                                                    src="https://winpeforum.com/assets/elements/SM_icon_01_new.png"
                                                    alt=""
                                                  />
                                                </a>
                                              </span>
                                              <span className="hicon">
                                                <a
                                                  style={{
                                                    display: "block !important",
                                                  }}
                                                  href={`https://twitter.com/intent/tweet?url=https://winpeforum.com${location.pathname}`}
                                                  target="_blank"
                                                  className=""
                                                >
                                                  <img
                                                    src="https://winpeforum.com/assets/elements/SM_icon_02_new.png"
                                                    alt=""
                                                  />
                                                </a>
                                              </span>
                                              <span className="hicon">
                                                <a
                                                  style={{
                                                    display: "block !important",
                                                  }}
                                                  href={`https://www.linkedin.com/sharing/share-offsite/?url=https://winpeforum.com${location.pathname}`}
                                                  target="_blank"
                                                  className=""
                                                >
                                                  <img
                                                    src="https://winpeforum.com/assets/elements/social_Media_icon_03_new_new.png"
                                                    alt=""
                                                  />
                                                </a>
                                              </span>
                                              <span className="hicon">
                                                <button
                                                  style={{
                                                    width: "25px",
                                                  }}
                                                  className="forwardMail"
                                                  title="Forward to email"
                                                  onClick={
                                                    this.toggleMailShareForm
                                                  }
                                                >
                                                  <img
                                                    src={emailForwardIcon}
                                                    alt=""
                                                  />
                                                </button>
                                              </span>
                                            </div>
                                          </div>
                                        </div>
                                      </ScrollAnimation>
                                    </div>
                                  );
                                })}
                              </div>
                              <div className="insights_blog_text_btm">
                                <div className="text_section">
                                  <div className="into_text">
                                    <span className="dis_line">
                                      Upping the Stakes is a forum for a candid
                                      and open dialogue between LPs and GPs on
                                      gender diversity featuring:{" "}
                                    </span>
                                    <span className="dis_line">
                                      <ul style={{ marginBottom: "0px" }}>
                                        {this.SpeakerContent.map((item, i) => {
                                          return (
                                            <li>
                                              <span
                                                className="dis_line"
                                                dangerouslySetInnerHTML={{
                                                  __html: item.fullname,
                                                }}
                                                onClick={() =>
                                                  this.togglePopUp(item)
                                                }
                                              ></span>
                                            </li>
                                          );
                                        })}
                                      </ul>
                                    </span>
                                    <span className="dis_line">
                                      Hear from industry leaders as they take
                                      stock of the state of gender diversity in
                                      the private equity/ venture capital
                                      ecosystem, share the progress made, and
                                      deliberate upon the way forward to
                                      building gender balance in investing and
                                      entrepreneurism.
                                    </span>
                                  </div>
                                  <div className="interview_vieo_section">
                                    <div className="interview_video">
                                      <div className="video_text">
                                        “The Alicorn Leadership Summit is a
                                        special series of events celebrating the
                                        power of gender diversity and marking
                                        Winpe's first anniversary.”
                                      </div>
                                      <div className="video_text">
                                        “Gender diversity to me means
                                        sustainability. Having a diverse
                                        leadership team is a great risk
                                        mitigator.”
                                      </div>{" "}
                                      <div className="video_text">
                                        “The biggest challenge for gender
                                        diversity is in implementation. A lot of
                                        firms and institutions want to do the
                                        right thing and have the policies in
                                        place, but just do not have the
                                        resources to track gender diversity. So
                                        if you equip them with resources you
                                        will see a lot more happening than just
                                        putting lipstick on the cover and
                                        walking away.”
                                      </div>{" "}
                                      <div className="video_text">
                                        “We are using a scorecard approach for
                                        key parameters of diversity. In our due
                                        diligence of GPs, we will be bringing
                                        this to action.”
                                      </div>{" "}
                                      <div className="video_text">
                                        “Gender diversity to me is opportunity.
                                        It is an extraordinary opportunity for
                                        us to benefit from extraordinary talent
                                        that we are not utilizing well enough
                                        yet.”
                                      </div>{" "}
                                      <div className="video_text">
                                        “As an industry, we have a problem- it
                                        is staring us in the face. Supporting
                                        efforts to help solve it and come up
                                        with innovative ways to do it is all of
                                        our responsibility. I would encourage
                                        all of our peers to join Winpe and solve
                                        the gender diversity problem as a
                                        responsibility to the industry.”
                                      </div>
                                      <div className="video_css1">
                                        <ReactPlayer
                                          width="100%"
                                          height="100%"
                                          style={{
                                            margin: "0 auto",
                                            padding: "0",
                                            borderRadius: "0px",
                                            background: "#000000",
                                            cursor: "pointer",
                                          }}
                                          controls={!!true}
                                          url="https://www.youtube.com/watch?v=xV6uH_3UJpw"
                                          playing={false}
                                        />

                                        {/* <iframe
                                          width="560"
                                          height="315"
                                          src="https://www.youtube.com/embed/xV6uH_3UJpw"
                                          frameborder="0"
                                          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                          allowfullscreen
                                        ></iframe> */}
                                      </div>
                                    </div>
                                  </div>
                                  <div className="r_text_Q"></div>
                                  <div className="r_text_Q"></div>
                                  <div className="r_text">
                                    <div
                                      className="para"
                                      style={{ padding: "20px 0px 0px 0px" }}
                                    ></div>
                                  </div>
                                </div>
                                <div className="footer_sm_icon">
                                  <div className="headsocialLink">
                                    <span className="hicon">
                                      <a
                                        href={`https://www.facebook.com/sharer/sharer.php?u=https://winpeforum.com${location.pathname}`}
                                        target="_blank"
                                        className=""
                                        style={{ display: "block !important" }}
                                      >
                                        <img
                                          src="https://winpeforum.com/assets/elements/SM_icon_01_new.png"
                                          alt=""
                                        />
                                      </a>
                                    </span>
                                    <span className="hicon">
                                      <a
                                        style={{ display: "block !important" }}
                                        href={`https://twitter.com/intent/tweet?url=https://winpeforum.com${location.pathname}`}
                                        target="_blank"
                                        className=""
                                      >
                                        <img
                                          src="https://winpeforum.com/assets/elements/SM_icon_02_new.png"
                                          alt=""
                                        />
                                      </a>
                                    </span>
                                    <span className="hicon">
                                      <a
                                        style={{ display: "block !important" }}
                                        href={`https://www.linkedin.com/sharing/share-offsite/?url=https://winpeforum.com${location.pathname}`}
                                        target="_blank"
                                        className=""
                                      >
                                        <img
                                          src="https://winpeforum.com/assets/elements/social_Media_icon_03_new_new.png"
                                          alt=""
                                        />
                                      </a>
                                    </span>
                                    <span className="hicon">
                                      <button
                                        style={{
                                          // display: "none",
                                          width: "25px",
                                        }}
                                        className="forwardMail"
                                        title="Forward to email"
                                        onClick={this.toggleMailShareForm}
                                      >
                                        <img src={emailForwardIcon} alt="" />
                                      </button>
                                    </span>
                                  </div>
                                </div>
                              </div>
                              <div className="back_event">
                                <Link to="/insights">
                                  <i className="fa fa-arrow-left">
                                    {" "}
                                    browse Insights
                                  </i>
                                </Link>
                              </div>
                            </div>
                          </div>
                        </ScrollAnimation>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <TeamModal
                show={isShow}
                onHide={this.togglePopUp}
                activeItem={this.state.activeItem}
              />
            </div>
          </div>
        </ContentPage>
      </div>
    );
  }
}
uppingthestakes.propTypes = {
  location: PropTypes.object,
};

export default uppingthestakes;



// WEBPACK FOOTER //
// ./src/pages/insights/uppingthestakes.js